import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';

// import actions
import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';

const PageTermsOfUse = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.terms]);
  });

  useEffect(() => {
    trackPageview({ title: 'Terms Of Use', path: props.path });
  }, []);

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.terms);
  });

  const { title = 'Terms of Use', description = '' } = pageData?.content || {};

  return (
    <div className="blue-background terms-of-use">
      <div className="container">
        <SiteMetaData {...meta} />
        <h1 style={{ textAlign: 'center', marginBottom: 45 }}>{title}</h1>
        <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </div>
  );
};

export default PageTermsOfUse;
